import {scriptonload} from "./scriptonload";
import {checkVisibility} from "./checkVisibility";

var ads = function (el) {
	var param = JSON.parse(el.getAttribute('data-param')),
		uid = param.uid,
        adsObj = {}, //возвращаемый объект
		insertYandexRTB = function(){
			var func = function(w, d, n, s, t) {
					w[n] = w[n] || [];
					w[n].push(function() {
						Ya.Context.AdvManager.render({
							blockId: blockId,
							renderTo: renderTo,
							async: true
						});
					});
					t = d.getElementsByTagName("script")[0];
					s = d.createElement("script");
					s.type = "text/javascript";
					s.src = "//an.yandex.ru/system/context.js";
					s.async = true;
					t.parentNode.insertBefore(s, t);
				},
                renderTo =  el.getAttribute('id'),
				blockId = renderTo.replace('yandex_rtb_', '');

			//
			func(window, window.document, "yandexContextAsyncCallbacks");
		},
        insertGoogle = function(){
            scriptonload('//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', function(){
                (adsbygoogle = window.adsbygoogle || []).push({});
            });
        },
        insertGoogleTag = function(){
            try{
            	var slot;
            	var frame = el.querySelector('[data-ads-frame]'); /* TODO нужно не нужно */
            	var progressEl = el.querySelector('[data-ads-progress]');
                var callback = function(){
                    googletag.cmd.push(function() {
                        googletag.pubads().refresh([slot]);
                    });
                    //console.log('googletag refresh');
				};
                var param = {
                	box:el,
					progressEl:progressEl,
					callback:callback
				}

				//
                googletag.cmd.push(function() {
                    slot = googletag.defineSlot('/21624868510/ka_side/ka_side_3', [[300, 300], [160, 600], [300, 500], [240, 600], [300, 600], [240, 400]], 'div-gpt-ad-1549951781921-0').addService(googletag.pubads());
                    googletag.display('div-gpt-ad-1549951781921-0');
                });

                checkVisibility(param);

			} catch(e){
            	//console.log('GoogleTag не отработал', e)
            }
        },
        insertAdfox = function(){
            var blockData = APP.ads.adFox.blocks[uid];

            try{
                if(blockData.obj === undefined){
                    window.Ya.headerBidding.pushAdUnits(blockData.adUnits);
                    blockData.obj = window.Ya.adfoxCode.create({
                        ownerId: 275464,
                        containerId: uid,
                        params: blockData.params,
                        onLoad: function(data) {console.log('Adfox Load', 'Банер загрузился')},
                        onRender: function() {console.log('Adfox Render', 'Код вставлен в контейнер')},
                        onError: function(err) {onError('Adfox', err); console.log('Adfox error', err)},
                        onStub: function(){onError('Adfox'); console.log('Adfox Stub', 'cервер вернул пустоту')}
                    });
                } else{
                    blockData.obj.initialize();
                }

                if(param.reload){
                    var progressEl = el.querySelector('[data-ads-progress]');
                    var callback = function(){
                        window.Ya.adfoxCode.reload(uid);
                    };
                    var visibilityParam = {
                        box:el,
                        time:param.reload.time*1000 || 30000,
                        progressEl:progressEl || false,
                        callback:callback
                    };

                    //
                    checkVisibility(visibilityParam);
                }

                adsObj = {
                    destroy: function(){
                        console.log('Удаляем банер');
                        blockData.obj.destroy();
                    }
                }

            } catch(e){
            	onError('Adfox', e);
            }
        },
		onError = function(system, err){
			console.log(4444444444444444444);
			el.parentElement.removeChild(el);
            console.log('система ' + system + 'не отработала. uid - ' + uid, err);
		},
    	init = function(){
			eval('insert' + param.name + '()');
		};

	//
	init();
    return adsObj;
};

export {ads};